module.exports = __webpack_public_path__ + "img/tapak-semaian-kelapa-tacunan-1.d0716af8.jpeg";